export const IconName = {
  Home: 'home',
  Settings: 'settings',
  LegalAssistant: 'legal-assistant',
  LegalMemo: 'legal-memo',
  DocDrafting: 'doc-drafting',
  DocReview: 'doc-review',
  CopyText: 'copy-text',
  InsertText: 'insert-text',
  Like: 'like',
  Dislike: 'dislike',
  Clip: 'clip',
  Send: 'send',
  LogoEs: 'logo-es',
  LogoFr: 'logo-fr',
  LightBulb: 'light-bulb',
  History: 'history',
  ChevronDown: 'chevron-down',
  Info: 'info',
  Document: 'document',
  MoreOptions: 'more-options',
  Close: 'close',
  PanelClose: 'panel-close',
  PanelOpen: 'panel-open',
  CaretUp: 'caret-up',
  GenericCross: 'generic-cross',
  NewConversation: 'new-conversation',
  DocComparison: 'doc-comparison',
  ArrowSquareOut: 'arrow-square-out',
  FolderSimpleUser: 'folder-simple-user',
  SignOut: 'sign-out',
  RocketLaunch: 'rocket-launch',
  NotePencil: 'note-pencil',
  X: 'X',
  Warning: 'warning',
  CircleCheck: 'circle-check',
  FileCloud: 'file-cloud',
  FileUser: 'file-user',
  CounterClock: 'counter-clock',
  User: 'user',
  Trash: 'trash'
} as const;

export const IconSize = {
  HeadlineXL: 'headline-xl',
  HeadlineL: 'headline-l',
  HeadlineM: 'headline-m',
  HeadlineS: 'headline-s',
  HeadlineXS: 'headline-xs',
  BodyXL: 'body-xl',
  BodyL: 'body-l',
  BodyM: 'body-m',
  BodyS: 'body-s',
  BodyXS: 'body-xs',
  LinkL: 'link-l',
  LinkM: 'link-m',
  LinkS: 'link-s',
  LinkXS: 'link-xs'
} as const;

// Exportamos los tipos para TypeScript
export type IconName = (typeof IconName)[keyof typeof IconName];
export type IconSize = (typeof IconSize)[keyof typeof IconSize];
